import { useEffect, useState } from "react";
import capHero from "@/assets/cap-hero-full.jpg.asset.json";
import { UNLOCK_DATE } from "@/App";

interface LockScreenProps {
  onUnlock: () => void;
}

const CORRECT_CODE = "607";

const LockScreen = ({ onUnlock }: LockScreenProps) => {
  const [code, setCode] = useState("");
  const [error, setError] = useState(false);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, []);

  const diff = Math.max(0, UNLOCK_DATE.getTime() - now);
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const minutes = Math.floor((diff % 3_600_000) / 60_000);
  const seconds = Math.floor((diff % 60_000) / 1000);
  const pad = (n: number) => n.toString().padStart(2, "0");

  useEffect(() => {
    if (error) {
      const t = setTimeout(() => setError(false), 1500);
      return () => clearTimeout(t);
    }
  }, [error]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.trim() === CORRECT_CODE) {
      onUnlock();
    } else {
      setError(true);
      setCode("");
    }
  };

  return (
    <main className="min-h-screen w-full flex items-center justify-center px-6 relative overflow-hidden">
      {/* Hintergrundbild: Cap-Foto von der Startseite */}
      <img
        src={capHero.url}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />
      <div className="absolute inset-0 bg-white/55 z-10" aria-hidden="true" />

      <div className="flex flex-col items-center gap-10 w-full max-w-md relative z-20">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-heading text-black tracking-[0.25em] text-center uppercase">
          New Caps Dropping
        </h1>

        <div className="text-3xl sm:text-4xl md:text-5xl font-heading text-black tracking-[0.2em] tabular-nums">
          {days > 0 && <span>{days}d </span>}
          {pad(hours)}:{pad(minutes)}:{pad(seconds)}
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col items-center gap-4 w-full">
          <input
            type="text"
            inputMode="numeric"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Enter Code"
            maxLength={3}
            autoFocus
            className={`w-full max-w-[220px] text-center text-lg tracking-[0.4em] bg-transparent border-b ${
              error ? "border-red-500" : "border-black/40"
            } text-black placeholder:text-black/30 outline-none py-2 transition-colors`}
          />
          <button
            type="submit"
            className="text-xs tracking-[0.3em] text-black/60 hover:text-black transition-colors uppercase"
          >
            Enter
          </button>
          {error && (
            <span className="text-xs tracking-[0.2em] text-red-500 uppercase">
              Wrong Code
            </span>
          )}
        </form>
      </div>
    </main>
  );
};

export default LockScreen;
